import GsapCarousel from '../library/GsapCarousel'
export default class CustomersCarousel {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.slides = this.el.querySelectorAll('[data-customer]')
  }

  init() {
    if (this.slides.length > 1) {
      GsapCarousel.init({
        el: this.el,
        slideshowCls: 'gsap-slideshow',
        slideshowContainerCls: 'gsap-slideshow-container',
        slideCls: 'gsap-slide',
        slideInner: 'gsap-slideshow-inner',
        slidesSelector: '[data-customer]',
        containerSelector: '[data-customers-container]',
        innerSelector: '[data-customers-inner]',
        slideDelay: 10,
        rotate: false,
        duration: 0.25,
        dotNav: false,
        debug: false,
        navGroup: true,
        autoContainerHeight: false,
        equalizeHeight: true,
        bleed: true,
        overflow: 'visible',
        nextButton: '[data-next]',
        prevButton: '[data-prev]',
      })
    }
  }
}
